import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { PedidoService } from '@mobile/app/services/pedido/pedido.service';
import { PedidosFirebaseService } from '@mobile/app/services/firebase/pedidos-firebase.service';
import { IPedido } from '@mobile/models/pedido/pedido.model';
import { StatusPedidoEnum } from '@mobile/models/status-pedido.enum';

@Component({
  selector: 'app-status',
  templateUrl: './status.page.html',
  styleUrls: ['./status.page.scss'],
})
export class StatusPage implements OnInit {
  pedidos: IPedido[] = [];
  id: string[] = [];
  loading: boolean = true;
  StatusPedidoEnum = StatusPedidoEnum;
  constructor(
    private modalCtrl: ModalController,
    private pedidosService: PedidosFirebaseService,
    private storage: Storage,
    private router: Router,
    private alertCtrl: AlertController,
    private pedidoService: PedidoService,
  ) { }

  async ngOnInit() {
    // this.id = await this.storage.get('pedidoEfetuado');
    // if (this.id) {
    //   this.atualizarPedido(this.id);
    // }

    this.pedidoService
      .getPedidoEfetuado()
      .subscribe(pedidoEfetuado => {
        this.id = pedidoEfetuado || [];
        this.atualizarPedido(this.id);
      });
  }

  doRefresh(event: any) {
    setTimeout(() => {
      this.atualizarPedido(this.id).then(() => event.target.complete());
    }, 500);
  }

  async atualizarPedido(id: string[]) {
    let pedidoAberto = id.length;
    let index = id.length - 1;
    id.forEach(async ped => {
      let pedido = await this.pedidosService.getPedido(ped);

      if (!pedido) {
        index--;
        return;
      }

      if (pedido.status > 1 && (pedido.pagamento == 'pontos' || pedido.pontos_utilizados > 0)) {
        this.storage.remove('pedidoPontos');
      }

      this.pedidos[index] = pedido;
      // Apenas remove pedidos ENTREGUES automaticamente (status 4)
      // Pedidos CANCELADOS (status 5) permanecem visíveis para o usuário
      if (pedido.status === StatusPedidoEnum.ENTREGUE) {
        pedidoAberto--;
        if (pedidoAberto == 0) {
          // Verifica se ainda há pedidos cancelados para mostrar
          const temPedidoCancelado = this.pedidos.some(p => p?.status === StatusPedidoEnum.CANCELADO);
          if (!temPedidoCancelado) {
            this.storage.remove('pedidoEfetuado');
            this.storage.remove('pedidoPontos');
            this.closeModal();
          }
        }
      }
      index--;
    });
  }

  async presentHelpAlert() {
    const alert = await this.alertCtrl.create({
      header: 'Ajuda',
      subHeader: "Alterações ou cancelamentos devem ser feitos com o restaurante. (13) 3024-2126",
      buttons: [
        {
          text: 'Ok',
          role: 'cancel'
        }
      ]
    });
    await alert.present();

  }

  /**
   * Remove um pedido cancelado da visualização do usuário
   */
  async removerPedidoCancelado(pedidoId: string) {
    const alert = await this.alertCtrl.create({
      header: 'Remover Pedido',
      message: 'Deseja remover este pedido cancelado da lista?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Remover',
          handler: async () => {
            // Remove do array local
            this.pedidos = this.pedidos.filter(p => p?.id !== pedidoId);

            // Remove do storage
            let pedidosEfetuados = this.id.filter(id => id !== pedidoId);
            this.id = pedidosEfetuados;

            if (pedidosEfetuados.length === 0) {
              await this.storage.remove('pedidoEfetuado');
              await this.storage.remove('pedidoPontos');
              this.closeModal();
            } else {
              await this.storage.set('pedidoEfetuado', pedidosEfetuados);
            }

            // Atualiza o serviço
            this.pedidoService.setPedidoEfetuado(pedidosEfetuados);
          }
        }
      ]
    });
    await alert.present();
  }

  goToHome() {
    this.router.navigateByUrl('/tabs/home');
    // this.closeModal();
  }
  async closeModal() {
    try {
      await this.modalCtrl.dismiss();
    }
    catch (err) {
      this.router.navigateByUrl('/tabs/home');
    }
  }
}
